import { Eye, Edit, Trash2 } from "lucide-react";
import type { ActionItem } from "@/components/ui/actions-dropdown";
import type { ActionSurface } from "./types";

export interface EnrollmentProfileActionsContext {
  surface: ActionSurface;
  onView: () => void;
  onEdit: () => void;
  onDelete?: () => void;
}

const L = (s: ActionSurface, list: string, detail: string) =>
  s === "list" ? list : detail;

export function buildEnrollmentProfileActions(
  ctx: EnrollmentProfileActionsContext,
): ActionItem[] {
  const { surface } = ctx;
  const items: ActionItem[] = [];
  if (surface === "list") {
    items.push({ label: "View", icon: Eye, onClick: ctx.onView });
  }
  items.push({
    label: L(surface, "Edit", "Edit Enrollment Profile"),
    icon: Edit,
    onClick: ctx.onEdit,
  });
  if (ctx.onDelete) {
    items.push({
      label: L(surface, "Delete", "Delete Enrollment Profile"),
      icon: Trash2,
      onClick: ctx.onDelete,
      destructive: true,
    });
  }
  return items;
}
